import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Tag } from 'ui';

// Internal mapping: AssessmentStatusTags accepts legacy values for backward
// compatibility (callers pass 'big', 'xxl', 'medium', etc.), but Tag v2 only
// supports 'sm' | 'md' | 'lg'. Unknown values fall back to Tag's default ('md').
const TAG_SIZE_MAP = {
  small: 'sm',
  micro: 'sm',
  medium: 'md',
  default: 'md',
  large: 'lg',
  big: 'lg',
  xxl: 'lg',
};

const AssessmentStatusTags = ({ status, t, size, onClick }) => {
  const TAGS = {
    'assessment-assigned': { text: 'Lets go', icon: 'emoji-light-bulb' },
    'resource-assigned': { text: 'Lets go', icon: 'emoji-light-bulb' },
    'resource-delivered': { text: 'Turned in ok', icon: 'emoji-done' },
    'record-delivered': { text: 'Turned in ok', icon: 'emoji-done' },
    'resource-evaluated': { text: 'Grades published', icon: 'emoji-stars2' },
    'assessment-reassigned': { text: 'Reassigned', icon: 'emoji-face-with-sweat' },
    'assessment-evaluated': { text: 'Grades published', icon: 'emoji-stars2' },
    'one-day': { text: '1 day', icon: 'emoji-bomb' },
    late: { text: 'Late!', icon: 'emoji-astonished' },
    assigned: { text: 'Assigned', icon: 'emoji-smilling' },
    soon: { text: 'Coming soon', icon: 'emoji-bomb' },
    'turned-in': { text: 'Turned in ok', icon: 'emoji-done', iconColor: 'blue-400' },
    'turned-in-late': { text: 'Turned in late', icon: 'emoji-astonished' },
    'timed-out': { text: 'Timed out', icon: 'emoji-panic' },
    'due-date-tomorrow': { text: '1 day', icon: 'emoji-bomb' },
    'due-date-today': { text: 'Late!', icon: 'emoji-astonished' },
    'waiting-correction': { text: 'lemonade:Waiting correction', icon: 'emoji-clock' },
    'not-available': { text: 'Not available', icon: 'emoji-sad' },
  };

  return (
    <div
      className={`assessment-status-tags assessment-status-tags--${status} assessment-status-tags--${size} ${
        onClick ? 'assessment-status-tags--clickable' : ''
      }`}
      onClick={onClick}
    >
      <Tag label={t(TAGS[status].text)} rightIcon={TAGS[status].icon} size={TAG_SIZE_MAP[size]} />
    </div>
  );
};

AssessmentStatusTags.propTypes = {
  status: PropTypes.oneOf([
    'assessment-assigned',
    'resource-assigned',
    'resource-delivered',
    'resource-evaluated',
    'assessment-reassigned',
    'assessment-evaluated',
    'waiting-correction',
    'one-day',
    'late',
    'assigned',
    'soon',
    'turned-in',
    'turned-in-late',
    'timed-out',
    'not-available',
  ]),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  onClick: PropTypes.func,
  t: PropTypes.func,
};

AssessmentStatusTags.defaultProps = {
  status: 'assessment-assigned',
  size: 'medium',
  onClick: () => {},
};

export default withTranslation(['assigments'])(AssessmentStatusTags);
